import { RasterizerDescription } from './RasterizerDescription';

export class RasterizerState {
  description: RasterizerDescription;

  constructor(description: RasterizerDescription) {
    this.description = description;
  }
}
